module.exports = require("post-compile-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "post-compile-webpack-plugin"
// module id = 44
// module chunks = 0